import { useContext } from 'react';
import { AppContext } from '../../../contexts/AppContext';

export function useClient() {
    const { state } = useContext(AppContext);

    return state?.client;
}
